const attemptKey = 'vk-auth-attempt';
export const vkAttemptLifetime = 10 * 60 * 1000;

type Attempt = { state: string; codeVerifier: string; createdAt: number };
export type VkCallback = { code?: string | null; deviceId?: string | null; state?: string | null; error?: string | null };

function readAttempt(): Attempt | null {
    try {
        const value = JSON.parse(sessionStorage.getItem(attemptKey) ?? 'null');
        return value && typeof value.state === 'string' && typeof value.codeVerifier === 'string'
            && typeof value.createdAt === 'number' ? value : null;
    } catch { return null; }
}

export function saveVkAttempt(state: string, codeVerifier: string) {
    if (!/^[A-Za-z0-9_-]{32,128}$/.test(state) || !/^[A-Za-z0-9._~-]{43,128}$/.test(codeVerifier)) {
        throw new Error('Не удалось начать вход через VK. Повторите попытку.');
    }
    sessionStorage.setItem(attemptKey, JSON.stringify({ state, codeVerifier, createdAt: Date.now() }));
}

export function hasVkAttempt(state: string) { return readAttempt()?.state === state; }

export function clearVkAttempt(state: string) {
    if (hasVkAttempt(state)) sessionStorage.removeItem(attemptKey);
}

// BroadcastChannel reaches all tabs. Only the tab owning this state may exchange the code.
// Consume before the POST: duplicate broadcasts must not exchange a one-use code twice.
export function consumeVkCallback(payload: VkCallback) {
    const attempt = readAttempt();
    if (!attempt || !payload || payload.state !== attempt.state) return null;
    sessionStorage.removeItem(attemptKey);
    if (Date.now() - attempt.createdAt > vkAttemptLifetime || Date.now() < attempt.createdAt) {
        throw new Error('Время входа через VK истекло. Начните вход заново.');
    }
    if (payload.error) throw new Error('Вход через VK отменён или отклонён. Попробуйте ещё раз.');
    if (typeof payload.code !== 'string' || !payload.code.trim() ||
        typeof payload.deviceId !== 'string' || !payload.deviceId.trim()) {
        throw new Error('VK не передал данные для входа. Начните вход заново.');
    }
    return { code: payload.code, deviceId: payload.deviceId, state: attempt.state, codeVerifier: attempt.codeVerifier };
}

export function readVkCallback(search: string): VkCallback {
    const params = new URLSearchParams(search);
    return { code: params.get('code'), deviceId: params.get('device_id'), state: params.get('state'), error: params.get('error') };
}
